import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import './Footer.css';
import logo from '../logo-assets/GIEPEI - COMPACTO-ok.png';

const Footer: React.FC = () => {
  const [footerData, setFooterData] = useState({
    description: 'GRUPO INTERNACIONAL DE ESTUDO E PESQUISA EM EDUCAÇÃO DE INFÂNCIAS',
    email: 'info.giepei@gmail.com',
    location: 'Angola / Brasil'
  });

  useEffect(() => {
    const fetchFooterSettings = async () => {
      try {
        const settingsSnap = await getDoc(doc(db, 'settings', 'main'));
        if (settingsSnap.exists()) {
          const data = settingsSnap.data();
          setFooterData({
            description: data.footerDescription || footerData.description,
            email: data.contactEmail || 'info.giepei@gmail.com',
            location: data.contactLocation || 'Angola / Brasil'
          });
        }
      } catch (err) {
        console.error("Erro ao carregar configurações do footer:", err);
      }
    };
    fetchFooterSettings();
  }, []);

  return (
    <footer className="main-footer">
      <div className="container footer-container">
        <div className="footer-info">
          <img src={logo} alt="GIEPEI" className="footer-logo" />
          <p>{footerData.description}</p>
        </div>
        <div className="footer-links">
          <h4>Links de Interesse</h4>
          <ul>
            <li><a href="/">Início</a></li>
            <li><a href="/publicacoes">Publicações</a></li>
            <li><a href="https://www.youtube.com/@GIEPEI" target="_blank" rel="noopener noreferrer">YouTube</a></li>
            <li><a href="https://whatsapp.com/channel/0029VbCkEG6HFxOspdrwQb1g" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
          </ul>
        </div>
        <div className="footer-contact">
          <h4>Contacto</h4>
          <p>Email: <a href={`mailto:${footerData.email}`} className="footer-email-link">{footerData.email}</a></p>
          <p>Localização: {footerData.location}</p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} GIEPEI. Todos os direitos reservados.</p>
          <p style={{ fontSize: '0.75rem', marginTop: '0.4rem', opacity: 0.8, letterSpacing: '1px' }}>Desenvolvido por BRIDNOLOGY</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
